import { checkIsOneScreen } from '@/service/util';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import './index.scss';

export default class WelcomeHeader extends React.Component {
  render() {
    const isOneScreen = checkIsOneScreen()
    const { name } = this.props;
    return (
      <div className={`welcome-header ${isOneScreen ? 'is-new' : ''}`}>
        <div className="header-title">
          {!name && (
            <div className="minor-title">
              <FormattedMessage id="app.welcomeTo" />&nbsp;
            </div>
          )}
          <div className="main-title">
            {' '}
            <FormattedMessage id={isOneScreen ? "app.website" : "app.name"} />&nbsp;
          </div>
          {!!name && (
            <div
              className={`minor-title ${
                name.toUpperCase() === 'ERROR' ? 'main-title' : ''
              }`}
            >
              {name}
            </div>
          )}
        </div>
      </div>
    );
  }
}
